<template>
  <div class="w-full">
    <v-tabs color="primary" bg-color="primary" class="px-4">
      <v-tab
        v-if="tabContent"
        value="content"
        @click="tab = 'content'"
      >
        รายละเอียดสินค้า
      </v-tab>
      <v-tab
        v-if="tabCompare"
        value="compare"
        @click="tab = 'compare'"
      >
        เปรียบเทียบ
      </v-tab>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item value="content">
          <slot name="content"></slot>
        </v-window-item>

        <v-window-item value="compare">
          <slot name="compare"></slot>
        </v-window-item>
      </v-window>
    </v-card-text>
  </div>
</template>

<script>
export default {
  props: {
    tab: {
      type: String,
      default: 'content',
    },
    tabContent: {
      type: Boolean,
      default: false,
    },
    tabCompare: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
